const E = "@chrissgon/perfectui", O = "0.21.1", D = "Perfect UI", w = "An exceptionally lightweight and highly customizable CSS and JavaScript library for crafting elegant user interfaces.", L = "MIT", C = "module", T = "dist/perfectui.js", S = "./dist/index.d.ts", R = {
  dev: "vite",
  build: "vite build",
  preview: "vite preview",
  prepare: "husky",
  lint: "eslint ./src --fix",
  format: "prettier --write .",
  release: "vite build && bunx changelogen --release --publish --r"
}, M = {
  "@commitlint/config-conventional": "^19.4.1",
  "@types/node": "^20.10.4",
  "@typescript-eslint/eslint-plugin": "^7.5.0",
  "eslint-plugin-import": "^2.29.1",
  husky: "^9.1.5",
  prettier: "^3.2.5",
  sass: "^1.58.0",
  typescript: "^5.4.3",
  vite: "^5.2.8",
  "vite-plugin-dts": "^3.6.4"
}, q = "Christopher Gonçalves <chrissgon.dev@gmail.com>", N = {
  type: "git",
  url: "git+https://github.com/chrissgon/perfectui.git"
}, a = {
  name: E,
  version: O,
  displayName: D,
  description: w,
  private: !1,
  license: L,
  type: C,
  main: T,
  types: S,
  scripts: R,
  devDependencies: M,
  author: q,
  repository: N
}, I = ".accordion", g = ".accordion-item", x = ".checkbox[indeterminate]", _ = ".dropdown-trigger", b = ".dropdown", G = ".modal", P = ".modal:not(.static-backdrop)", $ = ".modal *[data-autoclose]", j = "*[data-modal]", B = ".modal[open]";
function p() {
  const e = document.querySelectorAll(
    x
  );
  for (const t of e) {
    if (!t)
      return;
    t.indeterminate = !0, t.onclick = () => {
      t.removeAttribute("indeterminate");
    };
  }
}
function y() {
  const e = document.querySelectorAll(
    g
  );
  for (const t of e)
    t.onclick = (o) => {
      if (!t || !o.target)
        return;
      const r = o.target.closest(I);
      if (t.parentElement !== r)
        return;
      const c = r.querySelectorAll(g);
      for (const s of c)
        s !== t && s.removeAttribute("open");
    };
}
function v() {
  const e = document.querySelectorAll(
    _
  );
  for (const t of e)
    t.onclick = (o) => {
      var u, d;
      const n = o.target;
      if (n.classList.contains("ignore") || n.closest(".ignore") !== null)
        return;
      const s = o.currentTarget.querySelector(b), i = (u = s == null ? void 0 : s.classList) == null ? void 0 : u.contains("visible");
      if (F({ dropdown: s }), (d = s == null ? void 0 : s.classList) == null || d.toggle("visible"), i)
        return;
      const l = (k) => {
        var f;
        const m = k.target;
        m.classList.contains("ignore") || m.closest(".ignore") !== null || ((f = s == null ? void 0 : s.classList) == null || f.remove("visible"), document.body.removeEventListener("click", l));
      };
      setTimeout(() => {
        document.body.addEventListener("click", l);
      }, 0);
    };
}
function F({ dropdown: e }) {
  const t = document.querySelectorAll(
    b
  );
  for (const o of t)
    e !== o && o.classList.remove("visible");
}
function h() {
  const e = document.querySelectorAll(
    P
  ), t = document.querySelectorAll(
    $
  ), o = document.querySelectorAll(
    j
  );
  for (const n of e)
    n.addEventListener("mousedown", (r) => {
      r.target === n && n.close();
    });
  for (const n of t)
    n.addEventListener("click", (r) => {
      if (!r.target)
        return;
      r.target.closest(
        G
      ).close();
    });
  for (const n of o)
    n.addEventListener("click", (r) => {
      if (!r.target)
        return;
      const c = document.querySelectorAll(
        B
      );
      for (const l of c)
        l.close();
      const s = r.target.getAttribute("data-modal"), i = document.querySelector(`#${s}`);
      i == null || i.show();
    });
}
function W(e) {
  if (Object.keys(e).length < 11)
    throw new Error(
      "setThemeColor: Insufficient tone range. Expect range 50 to 950"
    );
  for (const t in e) {
    const o = e[t];
    let n = "";
    if (!Array.isArray(o))
      throw new Error("setThemeColor: invalid type");
    if (o.length != 3)
      throw new Error(
        "setThemeColor: invalid rgb format. Expect [R, G, B] array"
      );
    n = o.join(","), document.documentElement.style.setProperty(`--theme${t}`, n);
  }
}
function K(e = "system") {
  var o, n;
  const t = window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches;
  if (e === "system" && t || e === "dark") {
    (o = document.querySelector("html")) == null || o.classList.add("dark");
    return;
  }
  (n = document.querySelector("html")) == null || n.classList.remove("dark");
}
function A() {
  return y(), p(), v(), h(), { Accordion: y, Checkbox: p, Dropdown: v, Modal: h, setMode: K, setThemeColor: W };
}
function U() {
  let e = !1;
  const t = () => e = !0, o = () => e = !1;
  new MutationObserver(function() {
    e || (t(), setTimeout(o, 1e3), A());
  }).observe(document.documentElement, {
    childList: !0,
    subtree: !0
  });
}
function z() {
  const e = A();
  Object.assign(window, { perfectui: e }), Object.assign(document, { perfectui: e });
}
(function e() {
  console.log(`🎨 ${a.displayName} - ${a.version}`);
  try {
    z(), U();
  } catch (t) {
    if (console.error(`🎨 ${a.displayName} - ${a.version} ERROR:`, t), process && process.server)
      return;
    setTimeout(e, 1e3);
  }
})();
export {
  y as Accordion,
  p as Checkbox,
  v as Dropdown,
  A as loadFunctions,
  K as setMode,
  W as setThemeColor
};
